import Model from '@/models/Model';
import api from '@/services/Api';

export default class Quote extends Model {
    get route () {
        return 'quotes';
    }

    static get className () {
        return 'Quote';
    }

    static send (id) {
        return api.post(`${this.route}/${id}/send`);
    }

    static accept (id, data) {
        return api.post(`${this.route}/${id}/accept`, data);
    }

    static decline (id) {
        return api.post(`${this.route}/${id}/decline`);
    }

    static duplicate (id) {
        return api.post(`${this.route}/${id}/duplicate`);
    }
}
